module.exports = __webpack_public_path__ + "img/panier.d2f2a47e.png";